import axios from 'axios';
const files_url = 'files/';
const estimate_file_url = 'send-estimate-file/';

export const ESTIMATE = 'estimate';
export const PROJECT = 'project';
export const IRRIGATION = 'irrigation';
export const WORK_ORDER = 'work_order';
export const VISIT = 'visit';

export function upload(url, payload) {
  return new Promise(function (resolve, reject) {
    var req = new XMLHttpRequest()
    req.open('put', url)

    req.onload = function () {
      if (req.status === 200) {
        return resolve(req.response)
      } else {
        return reject(Error(req.statusText))
      }
    }
    req.onerror = function () {
      return reject(Error('Network Error'))
    }
    req.send(payload)
  })
}

export default {
  async getFile() {
    return axios.get(files_url)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async getPresignedURL(payload, type, id, file_type, description = "") {
    let url = files_url + `presigned/?file_type=${file_type}&description=${description}&`;

    if (type === ESTIMATE) {
      url += `estimate_pk=${id}&`;
    }

    if (type === PROJECT) {
      url += `project_pk=${id}&`;
    }

    if (type === IRRIGATION) {
      url += `irrigation_pk=${id}&`;
    }

    if (type === WORK_ORDER) {
      url += `work_order_pk=${id}&`;
    }

    if (type === VISIT) {
      url += `visit=${id}&`;
    }

    return await axios.post(url, {
      'name': payload
    }).then((response) => {
      console.log(response.data);
      return response.data;
    }).catch(err => {
      console.log(err.response.data);
    })
  },
  async downloadFile(id) {
    const url = files_url + id + '/';
    return axios.get(url)
      .then((response) => {
        return response.data.url;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async deleteFile(id) {
    const url = files_url + id + '/';
    return axios.delete(url)
      .then((response) => {
        console.log(response.data);
        return true;
      }).catch(err => {
        console.log(err.response.data);
        return false;
      });
  },
  async uploadToAWS(url, e) {
    const reader = new FileReader();
    return await new Promise((resolve, reject) => {
      reader.onload = () => {
        upload(url, e).then((response) => {
          resolve(response);
        }).catch((error) => {
          reject(error);
        })
      }
      reader.readAsArrayBuffer(e)
    })
  },
  async sendEstimateFile(file_pk, estimate_pk) {
    const url = estimate_file_url + `?file_pk=${file_pk}&estimate_pk=${estimate_pk}`;
    return axios.post(url, {})
      .then((response) => {
        console.log(response.data);
      }).catch(err => {
        console.log(err.response.data);
      });

  }
}
